import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a64f80ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bubble-skill" }
const _hoisted_2 = { class: "bubble" }
const _hoisted_3 = { class: "bubble__bonus" }
const _hoisted_4 = { class: "bubble__level" }
const _hoisted_5 = { class: "bubble__experience" }
const _hoisted_6 = { class: "skill-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("span", { class: "bubble__exp-gained" }, _toDisplayString(_ctx.signed(_ctx.experienceGained)) + " " + _toDisplayString(_ctx.$t('exp')), 513), [
        [_vShow, _ctx.isExperienceDisplayed]
      ]),
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.signed(_ctx.bonus)) + " ", 1),
        _createElementVNode("button", {
          class: "bubble__bonus-button bubble__bonus-button--up",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setBonus(_ctx.bonus + 1)))
        }, [
          _createVNode(_component_Icon, { name: "Caret" })
        ]),
        _createElementVNode("button", {
          class: "bubble__bonus-button bubble__bonus-button--down",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setBonus(_ctx.bonus - 1)))
        }, [
          _createVNode(_component_Icon, { name: "Caret" })
        ])
      ]),
      _createElementVNode("div", {
        class: "bubble__bg",
        style: _normalizeStyle({ backgroundImage: _ctx.gradient })
      }, null, 4),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.skill.level), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.experience), 1)
    ]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(`skill__${_ctx.skill.name}`)), 1)
  ]))
}